var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.5,
    height: 21.5,
    rx: 10.75,
    fill: "url(#paint0_linear_6396_68928)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95833 7.01744C8.95833 6.70066 9.08418 6.39684 9.30818 6.17284C9.53218 5.94884 9.83599 5.823 10.1528 5.823H11.3472C11.664 5.823 11.9678 5.94884 12.1918 6.17284C12.4158 6.39684 12.5417 6.70066 12.5417 7.01744V9.40633H14.9306C15.2473 9.40633 15.5512 9.53217 15.7752 9.75618C15.9992 9.98018 16.125 10.284 16.125 10.6008V11.7952C16.125 12.112 15.9992 12.4158 15.7752 12.6398C15.5512 12.8638 15.2473 12.9897 14.9306 12.9897H12.5417V15.3786C12.5417 15.6953 12.4158 15.9992 12.1918 16.2232C11.9678 16.4472 11.664 16.573 11.3472 16.573H10.1528C9.83599 16.573 9.53218 16.4472 9.30818 16.2232C9.08418 15.9992 8.95833 15.6953 8.95833 15.3786V12.9897H6.56944C6.25266 12.9897 5.94885 12.8638 5.72484 12.6398C5.50084 12.4158 5.375 12.112 5.375 11.7952V10.6008C5.375 10.284 5.50084 9.98018 5.72484 9.75618C5.94885 9.53217 6.25266 9.40633 6.56944 9.40633H8.95833V7.01744Z",
    fill: "#342A47"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6396_68928",
    x1: 10.75,
    y1: 0,
    x2: 10.75,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF65E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ECC2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtn);
export default __webpack_public_path__ + "static/media/add_btn.31179b7c5f74717bd87b5ae04c47d0b4.svg";
export { ForwardRef as ReactComponent };